import type { PlayerData, PlayerDataUpdate } from "./types";

/**
 * Deep merges two objects
 * @param target The target object to merge into
 * @param source The source object to merge from
 * @returns A new object with properties from both target and source, with source taking precedence
 */
export function applyStateUpdate(
  playerData: PlayerData,
  update: PlayerDataUpdate,
): PlayerData {
  return { ...playerData, ...update.update };
}

/**
 * Whether any string or key in `value` holds a NUL character, which Postgres
 * jsonb cannot store.
 */
export function containsNulCharacter(value: unknown): boolean {
  // Iterative so deeply nested input yields a result rather than a stack overflow.
  const pending: unknown[] = [value];
  const seen = new Set<object>();
  while (pending.length > 0) {
    const current = pending.pop();
    if (typeof current === "string") {
      if (current.includes("\0")) {
        return true;
      }
      continue;
    }
    if (typeof current !== "object" || current === null || seen.has(current)) {
      continue;
    }
    seen.add(current);
    for (const [key, entry] of Object.entries(current)) {
      if (key.includes("\0")) {
        return true;
      }
      pending.push(entry);
    }
  }
  return false;
}
